import { render, staticRenderFns } from "./StockStoresList.vue?vue&type=template&id=2bc51b26&scoped=true"
import script from "./StockStoresList.vue?vue&type=script&lang=js"
export * from "./StockStoresList.vue?vue&type=script&lang=js"
import style0 from "./StockStoresList.vue?vue&type=style&index=0&id=2bc51b26&prod&lang=scss&scoped=true"
import style1 from "./StockStoresList.vue?vue&type=style&index=1&id=2bc51b26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc51b26",
  null
  
)

export default component.exports